import { useTranslation } from "react-i18next";

import { PIN_TYPE_ICON_MAP, pinStatusTranslations } from "components";
import { NotificationContainer } from "components/NotificationsCenter/components/ClaireNotification/components/NotificationContainer";

import type { NotificationRegistryConfig } from "components/NotificationsCenter/components";
import type { TFunction } from "i18next";
import type { Pin } from "models";

type PinStatusNotificationProps = {
  pin: Pin;
  closeToast: () => void;
};

export const getPinStatusNotificationStatusName = (pin: Pin, t: TFunction) =>
  pin.pin_status_id ? t(pinStatusTranslations[pin.pin_status_id].translation_key, pinStatusTranslations[pin.pin_status_id].default_message) : "";

export const PinStatusNotification = ({ pin, closeToast }: PinStatusNotificationProps) => {
  const { t } = useTranslation();

  return (
    <NotificationContainer
      icon={PIN_TYPE_ICON_MAP[pin.pin_type_id].icon}
      title={`#${pin.appointment?.wo_nr} ${t("v8_pin_status_update", "Pin Status Update")}`}
      description={getPinStatusNotificationStatusName(pin, t)}
      onCloseNotification={closeToast}
    />
  );
};

export const PinStatusNotificationConfig: NotificationRegistryConfig = {
  toastOptions: { style: { width: "400px", right: "80px" } },
  render: ({ pin, closeToast }) => (pin ? <PinStatusNotification pin={pin} closeToast={closeToast} /> : null)
};
